var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"button"},on:{"click":_vm.updateChk}},[(_vm.isChecked)?_c('svg',{staticClass:"checkmark"},[_c('use',{attrs:{"xlink:href":"#checkmark"}})]):_c('svg',{staticClass:"add_grey"},[_c('use',{attrs:{"xlink:href":"#add_grey"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }